import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ENavigationPath } from 'constants/path';
import { ContractResponseDtoContractStatusEnum } from 'libs/pinnacle-sdk';

interface ContractHeaderProps {
  referenceNumber: string;
  contractId: string;
  title: string;
  contractStatus: ContractResponseDtoContractStatusEnum;
}

const ContractHeader: React.FC<ContractHeaderProps> = ({
  referenceNumber,
  contractId,
  title,
  contractStatus,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleAddNewAdjustment = useCallback(() => {
    navigate(
      ENavigationPath.CONTRACT_NEW_ADJUSTMENT.replace(':contractId', contractId)
    );
  }, [navigate, contractId]);

  return (
    <div className="mb-6 p-4 bg-white rounded-lg shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div>
            <p className="text-sm text-gray-600">
              {t('contractDetail.pinnacleReferenceNumber')}: {referenceNumber}
            </p>
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          </div>
        </div>
        <button
          className="bg-[#1d67b6] text-white px-12 py-2 rounded-lg hover:bg-[#1d67b6]/90 transition-colors disabled:cursor-not-allowed"
          onClick={handleAddNewAdjustment}
          disabled={
            contractStatus === ContractResponseDtoContractStatusEnum.Cancelled
          }
        >
          {t('contractDetail.addNewAdjustment')}
        </button>
      </div>
    </div>
  );
};

export default ContractHeader;
